import { localized, msg } from "@lit/localize";
import { BaseExtraButton } from "@whilecat/core/editors/buttons/base-extra-button.js";
import { assertNotNull, requireNotNull } from "@whilecat/core/utils/validation.js";
import type { PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { CodeArea } from "../code-area.ts";

@localized()
@customElement("copy-button")
export class CopyButton extends BaseExtraButton {
    @property({ attribute: false }) codeArea!: CodeArea;

    constructor() {
        super("copy", "check-lg", msg("Copy"));
    }

    protected firstUpdated(_changedProperties: PropertyValues<this>) {
        super.firstUpdated(_changedProperties);

        requireNotNull(this.codeArea);
    }

    onClicked() {
        requireNotNull(this.shadowRoot);

        navigator.clipboard.writeText(this.getCodeAreaCode());

        super.playToggleAnimation(1500);
    }

    getCodeAreaCode() {
        assertNotNull(this.codeArea);
        return this.codeArea.getCode();
    }
}
